import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
  apiBaseUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly http = inject(HttpClient);
  private config: AppConfig | null = null;

  async loadConfig(): Promise<AppConfig> {
    if (this.config) {
      return this.config;
    }

    try {
      // Always use relative /api/Config — dev proxy and deployed Kestrel both
      // route it correctly. Avoids baking any absolute URL into the bundle.
      const response = await firstValueFrom(
        this.http.get<AppConfig>('/api/Config')
      );
      this.config = response;
      return this.config;
    } catch {
      // Fallback: same origin (correct for both local ng serve and deployed)
      this.config = {
        apiBaseUrl: `${window.location.protocol}//${window.location.host}`,
      };
      return this.config;
    }
  }

  getConfig(): AppConfig {
    if (!this.config) {
      throw new Error('Config not loaded. Call loadConfig() first.');
    }
    return this.config;
  }

  getApiBaseUrl(): string {
    // Return empty string before config loads so the interceptor skips prepending
    // and all requests remain relative (same-origin, co-located Kestrel).
    return this.config?.apiBaseUrl ?? '';
  }
}
